module.exports = __webpack_public_path__ + "img/chatgenie-logo-landing-beta.f80cd42a.png";